<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class']
      iconClass?: HTMLAttributes['class']
      /** The phone number to display. */
      phoneNumber?: string
      /** The text to display when there is no phone number. @default 'No Phone Number.' */
      noPhoneNumberText?: string

      /** Whether to show the phone icon. @default false */
      showIcon?: boolean
      testId?: string
      dataTestId?: string
    }>(),
    {
      showIcon: true
    }
  )
</script>
<template>
  <a
    v-if="phoneNumber"
    @click.stop
    :href="`tel:${phoneNumber}`"
    :class="cn('hover:text-link/80 flex items-center gap-2', props.class)"
  >
    <gat-icon
      v-if="props.showIcon"
      icon="Phone"
      :class="cn('size-4', props.iconClass)"
    />
    <span :data-testid="props.testId ?? props.dataTestId">{{
      phoneNumber?.gs_format('phone-number')
    }}</span>
  </a>
  <span v-else class="text-soft">{{
    noPhoneNumberText ?? 'No Phone Number.'
  }}</span>
</template>
